/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const collectionStatSchema = z.object({
  collectionId: z.number(),
  name: z.string(),
  posterPath: z.string().nullable().optional(),
  posterUrl: z.string().nullable().optional(),
  totalPassed: z.number(),
  totalFailed: z.number(),
  totalSkipped: z.number(),
  totalTimeSpent: z.number(),
  totalChallenges: z.number(),
  reviewedChallenges: z.number(),
});

export type ICollectionStat = z.infer<typeof collectionStatSchema>;
